import { Controller } from "@hotwired/stimulus"

// A plain full-screen overlay for one photo. Opened from any element with
// data-action="lightbox#open" and data-lightbox-url-param; closed by a click
// on the backdrop, the close button, or Escape.
export default class extends Controller {
  static targets = ["overlay", "image"]

  open(event) {
    const url = event.params.url
    if (!url) return
    this.imageTarget.src = url
    this.overlayTarget.hidden = false
    document.body.classList.add("overflow-hidden")
  }

  close() {
    if (this.overlayTarget.hidden) return
    this.overlayTarget.hidden = true
    this.imageTarget.removeAttribute("src")
    document.body.classList.remove("overflow-hidden")
  }

  // A click inside the photo itself is not a click on the backdrop.
  stop(event) {
    event.stopPropagation()
  }
}
